type Metrics = keyof UrlParams;

const METRICS_TO_TRACK: Metrics[] = ['user', 'lang'];

export { METRICS_TO_TRACK };
